export const environment = {
    //change prod to false
    production: false,
    apiURLEndpoint: "https://backend.dev.mips.aws.thorogood.com/",
    // apiURLEndpoint: "http://localhost:8000/",
    redirectUri: 'https://dev.mips.aws.thorogood.com/',
    // redirectUri: 'http://localhost:4200/',

};
